export const formControlLabelSx = (theme) => ({
  color: theme.palette.secondary.main,
  fontSize: '12px',
  margin: 0,
});
